export default "__VITE_ASSET__DlAjgN2j__"